import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Comment, CommentFilter, MovieModel, MovieViewLogFliter } from 'src/app/core/interfaces/movie.model';
import { Account, FollowItem } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';
import { MoviesService } from 'src/app/core/services/movies.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  loading: boolean = false;

  account: Account;
  authorised = false;
  accountId: number;
  loggedAccountId: number;

  tituloFavoritos = "Peliculas Favoritas";
  tituloRecientes = "Peliculas Vistas Este Mes";

  perfilNombre = "Nombre Persona";
  perfilVistasTotales = 0;
  perfilVistasMes = 0;

  perfilPelisFavoritas: MovieModel[] = [];
  perfilPelisRecientes: MovieModel[] = [];
  perfilUltimosComentarios: Comment[] = [];

  swiperConfig: SwiperConfigInterface;
  swiperIndex = 0;

  following: boolean = false;
  showFollow: boolean = true;

  followerAmount = 0;
  followingAmount = 0;

  followers: number[] = [];
  followings: number[] = [];

  modalFollowers: any;
  modalFollowing: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private moviesService: MoviesService,
    private router: Router,
    private accountService: AccountService,

  ) {
    this.swiperConfig = {
      slidesPerView: 2,
      spaceBetween: -10,
      navigation: false,
      breakpoints: {
        480: { slidesPerView: 3 },
        700: { slidesPerView: 4 },
        1000: { slidesPerView: 6 },
        1600: { slidesPerView: 8 }
      }
    }
  }

  ngOnInit(): void {
    this.chequearLoginYCargarDatos();
  }

  chequearLoginYCargarDatos() { //COMPRUEBA QUE ESTES LOGEADO Y CARGA TODO.

    this.accountService.getAccount().then(
      (res: Account) => {
        if (res) {

          if (res == null) {
            this.router.navigateByUrl('/login');
          }
          else {
            this.cargarIdDesdeLink();
            this.chequearYCargarAccount();
            this.loggedAccountId = res.id;
          }
        }
      },
      (error) => {
        this.router.navigateByUrl('/login');
      },
    );

  }

  cargarDatos() {
    this.modalFollowers = $('#modalFollowers');
    this.modalFollowing = $('#modalFollowing');
    this.cargarDatosExtras();
    this.cargarPeliculasFavoritas();
    this.cargarPeliculasRecientes();
    this.cargarCommentarios();
  }

  cargarIdDesdeLink() {
    this.activatedRoute.params.subscribe((params) => {

      this.accountId = parseInt(params.userId);
    });
  }

  chequearYCargarAccount() {
    this.accountService.getAccountById(this.accountId).then(
      (res: Account) => {
        if (res) {
          this.account = res;
          if (this.account == null) {
            this.router.navigateByUrl('/home');
          }
          else {
            this.authorised = true;
            this.cargarDatos(); //LLAMADA IMPORTANTE ACA SE CARGA TODO.
          }
        }
        else {
          this.router.navigateByUrl('/home');
        }
      },
      (error) => {
        this.router.navigateByUrl('/home');
      },
    );
  }

  cargarPeliculasFavoritas() {
    this.moviesService.GetFavoritesUserFilms(this.account.id).subscribe((resp: MovieModel[]) => {
      this.perfilPelisFavoritas = resp;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );
  }

  randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  cargarPeliculasRecientes() {

    let sub = moment();
    sub.subtract(sub.date(), "days");

    let filter: MovieViewLogFliter = {
      DateFrom: sub.format('YYYY-MM-DDTHH:mm:ss'),
      DateTo: moment().format('YYYY-MM-DDTHH:mm:ss'),
      UserId: this.accountId,
    }

    this.moviesService.getMoviesSeenByUser(filter).subscribe((res) => {
      let temp = [];
      res.forEach(log => {
        temp.push(log.movie);

        this.perfilPelisRecientes.push(log.movie);
      });
      this.perfilPelisRecientes = temp.slice(0, 6);
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );
  }

  cargarDatosExtras() {

    this.loading = true;
    this.perfilNombre = this.account.firstName + " " + this.account.lastName;

    let sub = moment();
    sub.subtract(sub.date(), "days");

    let filter: MovieViewLogFliter = {
      DateFrom: sub.format('YYYY-MM-DDTHH:mm:ss'),
      DateTo: moment().format('YYYY-MM-DDTHH:mm:ss'),
      UserId: this.accountId
    }

    //NUMERO VISTAS TOTALES
    this.moviesService.getUserTotalSeen(filter).subscribe((res) => {
      this.perfilVistasTotales = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );

    //NUMERO DE VISTAS ESTE MES
    this.moviesService.getUserMonthlySeen(filter).subscribe((res) => {
      this.perfilVistasMes = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );

    //FOLLOWING
    if (this.accountId == this.loggedAccountId) {
      this.showFollow = false;
      this.loading = false;
    }
    else {
      this.accountService.isFollowingAccount(this.loggedAccountId, this.accountId).subscribe((res) => {
        this.following = res;
        this.loading = false;
      },
        (error) => {
          Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
        }
      );
    }

    this.cargarFollows();

  }

  cargarCommentarios() { //SE VAN A MOSTRAR LOS PRIMEROS 3, SE PUEDE CAMBIAR LA CANTIDAD.
    let cantidad = 3;
    this.moviesService.getCommentsByUser(this.accountId).subscribe((res) => {

      this.perfilUltimosComentarios = res.slice(0, cantidad);


    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );

  }

  onFollow() {
    let follow: FollowItem = {
      id: 0,
      follower: this.loggedAccountId,
      followed: this.accountId,
    }
    this.accountService.addFollow(follow).subscribe((res) => {
      this.following = true;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );
  }

  onUnFollow() {
    this.accountService.deleteFollow(this.loggedAccountId, this.accountId).subscribe((res) => {
      this.following = false;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );
  }

  cargarFollows() {
    //cantidad de followers
    this.accountService.getFollowerAmount(this.account.id).subscribe((res) => {
      this.followerAmount = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

    //cantidad de followings
    this.accountService.getFollowingAmount(this.account.id).subscribe((res) => {
      this.followingAmount = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

    this.accountService.getFollowers(this.account.id).subscribe((res) => {
      res.forEach(f => {
        this.followers.push(f.follower);
      });
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

    this.accountService.getFollowing(this.account.id).subscribe((res) => {
      res.forEach(f => {
        this.followings.push(f.followed);
      });

    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

  }

  onOpenFollowers() {
    this.modalFollowers.modal('show');
  }

  onOpenFollowing() {
    this.modalFollowing.modal('show');
  }

  closeModalFollowers() {
    this.modalFollowers.modal('hide');
  }

  closeModalFollowing() {
    this.modalFollowing.modal('hide');
  }

}
